export interface Features {
  enableEmptyState: boolean;
  failingRequestRetriesOnSubmit: number;
}

export function initFeatureFlags(features: Features) {
  features.enableEmptyState = true;
  features.failingRequestRetriesOnSubmit = 20;
}
